import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedNotificationResponse } from '@app/models';
import { UserService } from './user.service';
import { OrganizationService } from './organization.service';

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private readonly API_URL = `${environment.evolloApiUrl}/api/v1/websocket-notifications`;
  private readonly APPLICATION_NAME = 'insighthub';

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private organizationService: OrganizationService
  ) {}

  /**
   * Retorna os headers de autenticação e organização
   */
  private getAuthHeaders(): HttpHeaders {
    let headers = new HttpHeaders();

    if (this.userService.jwtToken) {
      headers = headers.set('Authorization', `Bearer ${this.userService.jwtToken}`);
    }

    if (this.organizationService.currentOrganization?.alias) {
      headers = headers.set('organization', this.organizationService.currentOrganization.alias);
    }

    return headers;
  }

  /**
   * Busca notificações paginadas da API
   */
  public getNotifications(
    page: number = 0,
    size: number = 20
  ): Observable<PagedNotificationResponse> {
    const params = new HttpParams()
      .set('applicationName', this.APPLICATION_NAME)
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<PagedNotificationResponse>(this.API_URL, {
      params,
      headers: this.getAuthHeaders()
    });
  }

  /**
   * Marca uma notificação específica como lida
   */
  public markAsRead(id: number): Observable<void> {
    return this.http.patch<void>(`${this.API_URL}/${id}/read`, {}, {
      headers: this.getAuthHeaders()
    });
  }

  /**
   * Marca todas as notificações como lidas
   */
  public markAllAsRead(): Observable<void> {
    const params = new HttpParams().set('applicationName', this.APPLICATION_NAME);
    return this.http.patch<void>(`${this.API_URL}/read-all`, {}, {
      params,
      headers: this.getAuthHeaders()
    });
  }
}
